<template>
  <div class="card">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="讲解" name="first">

        <el-input v-model="formData.name" placeholder="请输入展厅名称" class="mar16" style="width:200px"></el-input>
        <el-date-picker v-model="formData.date" type="daterange" class="mar16" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
        <el-button type="primary">搜索</el-button>
        <el-button>重置</el-button>
        <m-table :column="column" :table-data="tableData" :total="400" @get-list="getList"></m-table>
      </el-tab-pane>
      <el-tab-pane label="策划" name="second">
        <el-input v-model="formData.name" placeholder="请输入展厅名称" class="mar16" style="width:200px"></el-input>
        <el-date-picker v-model="formData.date" type="daterange" class="mar16" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
        <el-button type="primary">搜索</el-button>
        <el-button>重置</el-button>
        <m-table :column="column" :table-data="tableData" :total="400" @get-list="getList"></m-table>
      </el-tab-pane>
      <el-tab-pane label="其他活动" name="third">
        <el-date-picker v-model="formData.date" type="daterange" class="mar16" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
        <el-button type="primary">搜索</el-button>
        <el-button>重置</el-button>
        <!-- <m-table :column="column" :table-data="tableData" :total="400" @get-list="getList"></m-table> -->
      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<script>
import mTable from './components/table.vue'
export default {
  components: {
    mTable
  },
  data() {
    return {
      activeName: "first",
      column: [],
      tableData: [],
      officeType: [{ label: "策划", value: "0" }, { label: "讲解", value: "1" }, { label: "服务", value: "2" }, { label: "其他活动", value: "3" },],
      formData: {
        name: "",
        date: ""
      }
    };
  },
  computed: {},
  watch: {},
  methods: {
    //
    getList(params) {
      // console.log(params)
      let type = this.$route.params.type
      let active = this.activeName

      this.tableData = [{
        date: '2016-05-02',
        name: '王小是虎',
        address: '上海市普陀区金沙江路 1518 弄',
        id: "1",
        status: "0"
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1517 弄',
        id: "2",
        status: "1"
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄',
        id: "3",
        status: "2"
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1516 弄',
        id: "4",
        status: "1"
      }]
    },
    //获取表头
    getColumn(type) {
      let val = type
      if (val == "first") {
        this.column = [
          { prop: "address", label: "展厅名称", width: "" },
          { prop: "date", label: "申请时间", width: "" },
          { prop: "date", label: "展厅类型", width: "" },
        ]
      } else if (val == "second" || val == "activity") {
        this.column = [
          { prop: "address", label: "活动名称", width: "" },
          { prop: "date", label: "申请时间", width: "" },
          { prop: "date", label: "类型", width: "" },
        ]
      } else if (val == "third") {
        this.column = [
          { prop: "name", label: "类型", width: 90 },
          { prop: "date", label: "报名时间", width: "" },
          { prop: "date", label: "服务日期", width: "" },
        ]
      }
    },
    //改变tabs
    handleClick(tab, event) {
      let params = { currentPage: 1, pageSize: 10 }
      this.getList(params);
      // console.log(tab);
    },
    //退出报名 切换志愿者类型
    btnClick(val) {
      let params = { currentPage: 1, pageSize: 10 }
      this.getList(params);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getColumn(this.activeName);
    let params = { currentPage: 1, pageSize: 10 }
    this.getList(params);
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
</style>
